<template>
	<v-container class="fill-height">
		<v-row>
			<v-col cols="12">
				<title-text>Activity Feed.</title-text>
			</v-col>
			<v-col cols="12">
				<div
					class="text-center text-h5 mt-16"
					v-if="activities.length == 0 && !isLoadingActivities"
				>
					No activity feed yet
				</div>
				<div v-if="isLoadingActivities">
					<v-skeleton-loader
						v-for="i in 10"
						:key="i"
						v-bind="attrs"
						type="list-item"
					></v-skeleton-loader>
				</div>
				<v-timeline align-top dense v-else>
					<v-timeline-item
						class="py-5"
						color="secondary"
						small
						v-for="(activity, idx) in activities"
						:key="idx"
					>
						<v-row class="pt-1">
							<v-col cols="12" md="3">
								<strong>
									{{ formatDate(activity.createdat, DateTime.TIME_24_SIMPLE) }}
									-
									{{ formatDate(activity.createdat, DateTime.DATE_HUGE) }}
								</strong>
							</v-col>
							<v-col>
								<div class="text-body-1">{{ activity.action }}</div>
							</v-col>
							<v-col cols="12" md="2">
								<div
									class="d-flex justify-start"
									:class="{
										'justify-end': !$vuetify.breakpoint.mdAndDown,
									}"
								>
									<v-chip
										small
										color="primary"
										class="caption text-capitalize"
										>{{ activity.module }}</v-chip
									>
								</div>
							</v-col>
						</v-row>
					</v-timeline-item>
				</v-timeline>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
	import TitleText from "@/components/dashboard/DbTitleText.vue";
	import { UserService } from "@/services/index.js";
	import { formatDate } from "@/utils/helpers.js";
	import { DateTime } from "luxon";

	export default {
		components: {
			TitleText,
		},
		data() {
			return {
				formatDate,
				isLoadingActivities: false,
				DateTime,
				activities: [],
				attrs: {
					class: "mb-1",
					boilerplate: false,
					elevation: 0,
				},
			};
		},
		methods: {
			async getLogs() {
				try {
					this.isLoadingActivities = true;
					let res = await UserService.getLogs();

					this.activities = res;
					this.isLoadingActivities = false;
				} catch (error) {
					this.isLoadingActivities = false;
				}
			},
		},
		mounted() {
			this.getLogs();
		},
	};
</script>
